BR.uploadprofile = function (map, layersControl, routing, profileVar) {
    UploadProfile = L.Control.extend({
        profName: null,
        startProfile:  null,
        _layerName: 'Tracklayer',
        _trackLayer: undefined,
        _bounds: undefined,
        _testLayer: L.layerGroup().addTo(map),
        _trackPoints: [],
        _maxTrackPoints: 200,
        _closeCanceled: true,
        _currentGeoJSON: {},
        _options: {
            format: undefined,
            showTrackLayer: true,
            showPointAsPoi: true,
            simplifyTolerance: -1,
            isTestMode: false,
            simplifyLastKnownGood: 0.001,
            shortcut: {
                open: 79, // char code for 'O'; used in conjunction with 'shift'
            },
        },


           cleanup: function (e) {
console.log("UploadProfile  14......");
            this._testLayer.clearLayers();
            if (
                this._trackLayer &&
                map.hasLayer(this._trackLayer) &&
                (!this._options.showTrackLayer || this._closeCanceled)
            ) {
                map.removeLayer(this._trackLayer);
                layersControl.removeLayer(this._trackLayer);
                this._trackLayer = undefined;
            }
            (this._bounds = undefined), (this._trackPoints = []);
            this._currentGeoJSON = {};
            this._options = {
                showTrackLayer: true,
                showPointAsPoi: true,
                simplifyTolerance: -1,
                isTestMode: false,
                simplifyLastKnownGood: 0.001,
                shortcut: {
                    open: 79, // char code for 'O'; used in conjunction with 'shift'
                },
            };
        },


         onBusyChanged: function (isBusy) {
console.log(" isBusy.....");
// kommt 2 mal währen file lesen
            if (typeof isBusy === undefined) {
                isBusy = false;
            }
            if (isBusy === true) $('#uploadprofile #msg_busy_profile').removeClass('invisible');
            else $('#uploadprofile #msg_busy_profile').addClass('invisible');
        },


        onAdd: function (map) {
console.log(" onAdd.....");
            $('#uploadprofile').on(
                'hidden.bs.modal',
                function (e) {
                    this.cleanup();
                }.bind(this)
            );
            $('#uploadprofile').on(
                'show.bs.modal',
                function (e) {
                    $('#manual_collapse').collapse('hide');
                    this._closeCanceled = true;
                }.bind(this)
            );

            L.DomUtil.get('submitUploadProfile').onclick = L.bind(function () {
console.log(" onclick submitUploadProfile.....");
// nack klick auf "LADEN" (nach file selection ...)
                this._closeCanceled = false;
                this.onBusyChanged(true);
                    setTimeout(
                        function () {
                            this.uplLocalProfile();
                            $('#uploadprofile').modal('hide');
                        }.bind(this),
                        0
                    );
console.log("UploadProfile  IF 2.....");
            }, this);


console.log("UploadProfile nach oninput .....");
            L.DomUtil.get('uploadProfileFile').onchange = L.bind(this.onFileChanged, this);
console.log("UploadProfile nach onchange .....");
            this.onFileChanged({ target: L.DomUtil.get('uploadProfileFile') });

console.log("UploadProfile addListener keydown.....");
            L.DomEvent.addListener(document, 'keydown', this.keydownListener, this);

            // dummy, no own representation, delegating to EasyButton
            var dummy = L.DomUtil.create('div');
            dummy.hidden = true;
            return dummy;
        },

        onRemove: function (map) {
            // Nothing to do here
        },

        onFileChanged: function (e) {
console.log("UploadProfile onFileChanged.....");

            if (!e.target.files[0]) 
      {
console.log("UploadProfile init phase " );

var profileCont = localStorage.getItem("BrouterStartProfile");
var profileShortName = localStorage.getItem("BrouterStartProfileName");

if (typeof profileCont === 'string') 
          {
    console.log("UploadProfile localstorage FOUND " + profileCont.substring(0, 20)); // ok

// load the editor!!!!!!!!!!!!!!!!!!!!!!
 profileVar._setValue(profileCont);


// activate the profile
          profileVar._uploadNew(profileVar, profileShortName );

 console.log("UploadProfile localstorage BrouterStartProfile found and activated!!!!!=" + profileShortName );
 return;
         }
else
         {
console.log("Uploadprofile localstorage NOT found !!!!!!!!!");
    return;

}

}
console.log("Uploadprofile ?????? continue !!!!!!!!!");
            $(e.target).next('label').text(e.target.files[0].name);
            var testmode = this._options.isTestMode;
            this.cleanup();
            this._options.isTestMode = testmode;
        },


        uplLocalProfile: function () {
console.log("UploadProfile  5......");
            if ($('#uploadProfileFile')[0].files.length == 0) return;
            this.onBusyChanged(true);

            var profileFile = $('#uploadProfileFile')[0].files[0];
            this._layerName = profileFile.name.replace(/\.[^\.]*$/, '');

            if (!this._options.format) this._options.format = profileFile.name.split('.').pop();

            var reader = new FileReader();
// initiate the processing....onload
            profName = profileFile.name;
            reader.onload = L.bind(this.processFile, this);


            reader.readAsText(profileFile);
            console.log("UploadProfile READER upload profilee..." + profileFile + " profileFile-name=" + profileFile.name);
            
        },

//   process file

        processFile: function (e) {
            var res = e.target.result;
console.log("BRF_File_Content GELESEN  res=" + res.substring(0, 30));

// load the editor 
    profileVar._setValue(res);

      var profNamShort = profName.replace(".brf", ""); 
// activate the profile 
      profileVar._uploadNew(profileVar, profNamShort);


// is this profile also to be activated at start?
    var exportForm = document.forms['uploadProfileForm'];
    var setLocalStorage = exportForm['setlocalStorage'].checked;

console.log("UploadProfile setLocalStorage=" + setLocalStorage + " ProfileText=" + res.substring(0, 30));

   if (setLocalStorage)
    {
// yes, store profile-content and profile name in the browser-locaStorage
             localStorage.setItem("BrouterStartProfile", res);
             localStorage.setItem("BrouterStartProfileName", profNamShort);
             console.log("UploadProfile localStorage were set!!!  key=BrouterStartProfile value =" + res.substring(0, 30)); 
    }
  

        },

        keydownListener: function (e) {
            if (
                BR.Util.keyboardShortcutsAllowed(e) &&
                e.keyCode === this._options.shortcut.open &&
                true === e.shiftKey
            ) {
                $('#profileUpload').click();
            }
        },
    });
console.log("UploadProfile  create at start");
    UploadProfile.include(L.Evented.prototype);

    var uploadprofileControl = new UploadProfile();
    uploadprofileControl.addTo(map);

    return uploadprofileControl;
};
